import type { MessageKey } from '@reos/i18n';

/**
 * Krok PROP5 bod 5 — JEDNA hláška k výsledku „Uložit přílohu k zakázce".
 *
 * Server vrací strojový kód v `problem.type` (`broker-inbox/attachment-…`),
 * text skládá katalog — stejný vzor jako `client-mail-message.ts`. Makléř musí
 * poznat ROZDÍL: „antivirus přílohu zadržel" je jiný stav než „e-mail už ve
 * schránce není", a obojí je jiné než „zkuste to znovu".
 */

/** Kódy, které `apps/api` u této akce vrací (viz `broker-mail-attachment-port.ts`). */
const REASON_KEYS: Readonly<Record<string, string>> = {
  'attachment-infected': 'infected',
  'attachment-unsupported-type': 'unsupported',
  'attachment-too-large': 'tooLarge',
  'attachment-empty': 'empty',
  'attachment-not-a-document': 'notADocument',
  'attachment-no-case': 'noCase',
  'attachment-mail-gone': 'mailGone',
  'attachment-changed': 'mailGone',
  'attachment-mailbox-unavailable': 'unavailable',
  'attachment-store-unavailable': 'unavailable',
};

/**
 * Klíč hlášky k důvodu. Neznámý kód (novější server, starší bundle) skončí na
 * neutrálním „Přílohu se uložit nepovedlo." — nikdy na prázdném místě, kde by
 * makléř myslel, že dokument u zakázky je.
 */
export function mailAttachmentReasonKey(problemType: string | null | undefined): MessageKey {
  const code = (problemType ?? '').replace(/^broker-inbox\//, '');
  return `webAdmin.mailbox.attachmentReason.${REASON_KEYS[code] ?? 'neznamy'}` as MessageKey;
}
